import React from 'react';
import PropTypes from 'prop-types';

const BaseSidebar = ({ 
  items, 
  onSectionChange, 
  activeSection, 
  title,
  transformItemText = (text) => text.toLowerCase(),
  isSidebarOpen,
  onToggle
}) => {
  return (
    <div className="w-full h-full overflow-y-auto">
      <div className="p-4 mb-2 min-h[calc(70vh-2rem)] md:min-h[calc(100vh-2rem)]">
        <div className="w-full h-full bg-btn-primary rounded-xl p-4">
          
          {title && (
            <h2 className="text-lg font-bold font-sans text-center text-white py-2 mb-4">
              {title}
            </h2>
          )}
          <div className="flex flex-col">
            {items.map((item) => (
              <div key={item} className="mb-1">
                <button
                  onClick={() => {
                    onSectionChange(transformItemText(item));
                    if (window.innerWidth < 768) onToggle?.();
                  }}
                  className={`block text-base md:text-lg w-full text-left py-2 px-3 rounded-lg 
                    transition-colors ${
                    activeSection === transformItemText(item)
                      ? 'bg-btn-secondary text-white'
                      : 'text-white hover:bg-btn-secondary-hover hover:text-white'
                  }`}
                >
                  {item}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

BaseSidebar.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSectionChange: PropTypes.func.isRequired,
  activeSection: PropTypes.string.isRequired,
  title: PropTypes.string,
  transformItemText: PropTypes.func,
  isSidebarOpen: PropTypes.bool,
  onToggle: PropTypes.func
};

export default BaseSidebar;